// import Navbar from "./Navbar";
// import Footer from "./Footer";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
// import FooterEn from "./Elements/FooterEn/FooterEn";
import MainNavbar1 from "./Elements/MainNavBar1/MainNavbar1";
import MainNavbar1Dark from "./Elements/MainNavBar1Dark/MainNavbar1Dark";
import MainNavbar1DarkEn from "./Elements/MainNavBar1Dark/MainNavbar1DarkEn";

import MinAndMaxWidthAlert from "./Elements/MinAndMaxWidthAlert/MinAndMaxWidthAlert";
import WpFooter from "./Elements/WpFooter/WpFooter";
import MainNavbar1En from "./Elements/MainNavBar1/MainNavbar1En";
import WpFooterEn from "./Elements/WpFooter/WpFooterEn";
import uuid from "react-uuid";
import WpFooterDark from "./Elements/WpFooter/WpFooterDark";

const Layout = ({ children }) => {
  const router = useRouter();
  const [isEn, setIsEn] = useState(false);
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (
      router.pathname.includes("/en") ||
      router.pathname.includes("/En") ||
      router.pathname.includes("/EN") ||
      router.pathname.includes("/eN")
    ) {
      setIsEn(true);
    } else {
      setIsEn(false);
    }

    if (
      router.pathname.includes("ta-code") ||
      router.pathname.includes("events") ||
      router.pathname.includes("onsight-register")
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [router.pathname]);
  return (
    <div lang={isEn ? "en" : "fa"} className="overflow-hidden">
      <MinAndMaxWidthAlert />
      <>
        {isEn ? (
          <div
            key={uuid()}
            dir="ltr"
            lang="en"
            className="overflow-hidden"
            prefix="og: https://ogp.me/ns#"
          >
            {isDark ? <MainNavbar1DarkEn /> : <MainNavbar1En />}
            {children}
            {/* <FooterEn /> */}
            <WpFooterEn />
          </div>
        ) : (
          <div key={uuid()} dir="rtl" lang="fa" className="overflow-hidden">
            {/* <Navbar /> */}
            {isDark ? <MainNavbar1Dark /> : <MainNavbar1 />}
            {children}
            {/* <Footer /> */}
            {isDark ? <WpFooterDark /> : <WpFooter />}
          </div>
        )}
      </>
    </div>
  );
};

export default Layout;
